module.exports = __webpack_public_path__ + "img/Lanchas_3.b49dadec.jpg";